import React from 'react';
import Profile from '../assets/img/profile.jpg';

const Menu = () => {

    const [toggle, setToggle] = React.useState({ status: false, text: "" });
    const imgRef = React.useRef(null);

    React.useEffect(() => {
        if (imgRef.current) {
            imgRef.current.style.setProperty('width', '120px', 'important');
        }


        /**
         * Toggle mobile nav dropdowns
         */
        document.querySelectorAll('.navmenu .toggle-dropdown').forEach(navmenu => {
            navmenu.addEventListener('click', function (e) {
                e.preventDefault();
                this.parentNode.classList.toggle('active');
                this.parentNode.nextElementSibling.classList.toggle('dropdown-active');
                e.stopImmediatePropagation();
            });
        });

        navmenuSpy();
        document.addEventListener('scroll', navmenuSpy);

        /**
        * Scroll top button
        */
        let scrollTop = document.querySelector('.scroll-top');

        function toggleScrollTop() {
            if (scrollTop) {
                window.scrollY > 100 ? scrollTop.classList.add('active') : scrollTop.classList.remove('active');
            }
        }
        scrollTop.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
        toggleScrollTop();
        document.addEventListener('scroll', toggleScrollTop);

        /**
        * Hide mobile nav on same-page/hash links
        */
        document.querySelectorAll('#navmenu a').forEach(navmenu => {
            navmenu.addEventListener('click', () => {
                if (document.querySelector('.header-show')) {
                    document.getElementById('header').classList.remove("header-show");
                    headerToggle();
                }
            });
        });

    }, []);

    /**
      * Header toggle
      */

    const headerToggle = () => {
        setToggle((prev) => ({
            ...prev,
            status: !prev.status
        }));

        const headerToggleBtn = document.querySelector('.header-toggle');
        headerToggleBtn.classList.toggle('bi-list');
        headerToggleBtn.classList.toggle('bi-x');
    }

    /**
     * Navmenu Scrollspy
     */
    const navmenuSpy = () => {
        let navmenulinks = document.querySelectorAll('.navmenu a');
        navmenulinks.forEach(navmenulink => {
            if (!navmenulink.hash) return;
            let section = document.querySelector(navmenulink.hash);
            if (!section) return;
            let position = window.scrollY + 300;

            if (position >= section.offsetTop && position <= (section.offsetTop + section.offsetHeight)) {
                document.querySelectorAll('.navmenu a.active').forEach(link => link.classList.remove('active'));
                navmenulink.classList.add('active');
            } else {
                navmenulink.classList.remove('active');
            }
        })
    }

    React.useEffect(() => {
        if (toggle.status) {
            setToggle((prev) => ({
                ...prev,
                text: 'header-show'
            }));
        }
        else {
            setToggle((prev) => ({
                ...prev,
                text: ""
            }))
        }
    }, [toggle.status])

    return (
        <>
            <header id="header" className={`header dark-background d-flex flex-column ${toggle.text}`}>
                <i className="header-toggle d-xl-none bi bi-list" onClick={() => headerToggle()} />
                <div className="profile-img">
                    <img
                        ref={imgRef}
                        src={Profile}
                        alt=""
                        style={{ height: "120px" }}
                        className="img-fluid rounded-circle"
                    />
                </div>
                <a
                    href="index.html"
                    className="logo d-flex align-items-center justify-content-center"
                >
                    <h1 className="sitename">Fajar Subhan</h1>
                </a>
                <div className="social-links text-center">
                    <a href="https://github.com/fajar-subhan" title='Github' rel='noreferrer' target='_blank' className="twitter">
                        <i className="bi bi-github"></i>
                    </a>
                    <a href="https://www.linkedin.com/in/fajar-subhan-951a9330b/" rel='noreferrer' title='LinkedIn' target='_blank' className="linkedin">
                        <i className="bi bi-linkedin" />
                    </a>
                </div>
                <nav id="navmenu" className="navmenu">
                    <ul>
                        <li>
                            <a href="#home" role='button'>
                                <i className="bi bi-house navicon" />
                                Home
                            </a>
                        </li>
                        <li>
                            <a href="#about" role='button'>
                                <i className="bi bi-person navicon" /> Tentang Saya
                            </a>
                        </li>
                        <li>
                            <a href="#portfolio" role='button'>
                                <i className="bi bi-images navicon" /> Portofolio
                            </a>
                        </li>
                        <li>
                            <a href="#services" role='button'>
                                <i className="bi bi-hdd-stack navicon" /> Keterampilan
                            </a>
                        </li>
                        <li>
                            <a href="#contact" role='button'>
                                <i className="bi bi-envelope navicon" /> Kontak
                            </a>
                        </li>
                    </ul>
                </nav>
            </header>
        </>
    )
}

export default Menu;